import { store } from '../redux/store';

export const logAnalyticsEvent = (event) => {
   if (window.dataLayer) {
      const state = store.getState();
      let { storeData: {store_domain: storeDomain, store_id: storeId}, userId } = state?.app;
      storeId = storeId || state?.app?.storeId || ""
      window.dataLayer.push({ event, userId, storeDomain, storeId });
   }
}